import React from 'react'
import FirebaseAuth from 'react-firebaseui/FirebaseAuth'
import firebase from 'firebase'
import { useFirebaseApp } from 'reactfire'

const uiConfig = {
    signInFlow: 'popup',
    signInSuccessUrl: '/',
    signInOptions: [firebase.auth.GoogleAuthProvider.PROVIDER_ID],
}

export const SignIn = () => {
    const firebaseApp = useFirebaseApp()
    return <FirebaseAuth uiConfig={uiConfig} firebaseAuth={firebaseApp.auth()} />
}

export default SignIn
